import React from "react";
import DownloadButton from "../Button/downloadButton";
import MailToButton from "../Button/mailToButton";
import Jumbotron from "../Jumbotron";

const Navbar = () => (
  <Jumbotron zIndex="9999" justifyContent="flex-end" position="fixed" bg="white">
    <MailToButton 
      mailAddress="rajanlagah@gmail.com"
      text="Connect"
      flexGrow="unset"
      fontSize="16px"
      color="#222"
      padding="10px"
      fontWeight={500}
    />
    <DownloadButton
      text="Download CV"
      handleOnClick={() => undefined}
      flexGrow="unset"
      fontSize="16px"
      color="#222"
      padding="10px"
      fontWeight={500}
      downloadFileName="./RajanSDE2Resume.pdf"
    />
  </Jumbotron>
);

export default Navbar;
